import { Breakpoints, BreakpointWrapper, styled } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import FeatureHighlights from '../../FeatureHighlights';
import { ResultsView, ResultsViewContext } from '../../../utils/results-view-context';
import { VehicleData } from '../../../types';
import SoldDescription from '../../SoldDescription';
import DealershipMoved from '../../DealershipMoved';
import { VehicleContext } from '../../../utils/vehicle-context';

interface CardDescriptionContainerInterface {
  view: ResultsView;
}

interface CardDescriptionInterface {
  sold?: boolean;
  vehicle: VehicleData;
}

const CardDescriptionContainer = styled.div<CardDescriptionContainerInterface>`
  grid-area: description;
  display: none;

  div[class^='StyledContainer'] {
    padding-left: 0;
  }

  @media (min-width: ${Breakpoints.b960}px) {
    display: ${({view}) => view === ResultsView.GRID ? 'none' : 'flex'};
    flex-direction: column;
    justify-content: space-between;
    margin-top: ${props => props.theme.size.static150};
    margin-bottom: ${props => props.theme.size.static150};
    padding-left: 36px;
  }
`;

const CardDescription : React.FC<CardDescriptionInterface> = () => {

  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext) as VehicleData;
  const sold = vehicle.deleted;

  return !sold ?
    view != ResultsView.GRID ? (
      <BreakpointWrapper min={Breakpoints.b960}>
        <CardDescriptionContainer view={view}>
          <FeatureHighlights
            category={vehicle.category}
            features={vehicle.feature_highlights}
            description={vehicle.description} />

            {vehicle &&
              vehicle.previous_dealer_id &&
              vehicle.previous_dealer_info && <DealershipMoved dealer={vehicle.previous_dealer_info} />}

        </CardDescriptionContainer>
      </BreakpointWrapper>
    ) : null
  : <SoldDescription vehicle={vehicle} />
}

export default CardDescription;
